import { create } from "zustand";

import { TargetingForm } from "@stw/yup-validators";

import { GetAudienceSearchUserFilterQuery } from "~frontend/__generated__/graphql";

export interface AudienceState {
  activeAudienceSearchFilter:
    | GetAudienceSearchUserFilterQuery["getAudienceSearchUserFilter"]
    | null;
  setActiveAudienceSearchFilter: (
    filter:
      | GetAudienceSearchUserFilterQuery["getAudienceSearchUserFilter"]
      | null
  ) => void;
  currentFilter: TargetingForm & {
    id?: string;
    name?: string;
    contactCount?: number;
  };
  setFilter: (
    filter: TargetingForm & {
      id?: string;
      name?: string;
      contactCount?: number;
    }
  ) => void;
  clearFilters: () => void;

  isFilterEmpty: () => boolean;

  isEditingExistingFilter: boolean;
  toggleIsEditingExistingFilter: () => void;
}

export const useAudience = create<AudienceState>()((set, getState) => ({
  activeAudienceSearchFilter: null,
  setActiveAudienceSearchFilter: (
    activeAudienceSearchFilter:
      | GetAudienceSearchUserFilterQuery["getAudienceSearchUserFilter"]
      | null
  ) => set({ activeAudienceSearchFilter }),
  currentFilter: { targetGroups: [], name: "" },
  setFilter: (
    filter: TargetingForm & {
      id?: string;
      name?: string;
      contactCount?: number;
    }
  ) => set({ currentFilter: filter }),
  isFilterEmpty: () => {
    const { currentFilter } = getState();
    return (
      !currentFilter.targetGroups || currentFilter.targetGroups.length === 0
    );
  },
  clearFilters: () =>
    set({
      currentFilter: { targetGroups: [] },
      isEditingExistingFilter: false,
    }),
  isEditingExistingFilter: false,
  toggleIsEditingExistingFilter: () => {
    const isEditing = getState().isEditingExistingFilter;
    return set({ isEditingExistingFilter: !isEditing });
  },
}));
